import React from "react";

const DetailDescription = ({ description, details }) => {
  if (!description) return <div>No description available</div>;

  const paragraphs = (description.course_desc || "")
    .split(/(?<=[.!?])\s+/)
    .filter((sentence) => sentence && sentence.trim());

  const question = description.course_info?.question || "Who this course is for";
  const answers = description.course_info?.answer || [];
  const syllabus = description.syllabus || (details?.features || []).map((item, index) => ({
    title: `Module ${index + 1}: ${item.title}`,
    body: item.title,
  }));

  return (
    <div className="course-description box">
      <span className="d-inline-block px-3 py-1 rounded-pill bg-light text-dark fw-semibold small text-uppercase">
        Course Overview
      </span>
      <h4 className="mt-3 mb-3 fw-bold">What you will learn</h4>

      {paragraphs.map((sentence, index) => (
        <p key={index} className="mb-3 text-white lh-lg">
          {sentence.trim()}
        </p>
      ))}

      <h5 className="mt-4 mb-3 fw-bold">{question}</h5>
      <ul className="list-unstyled mb-0">
        {answers.map((ans, index) => (
          <li key={index} className="mb-2 d-flex align-items-start gap-2">
            <i className="fas fa-check-circle text-success mt-1"></i>
            <span>{ans}</span>
          </li>
        ))}
      </ul>

      <h5 className="mt-4 mb-3 fw-bold">Course Syllabus</h5>
      <div className="accordion accordion-flush shadow-sm rounded-3 overflow-hidden" id="course-syllabus-accordion">
        {syllabus.map((item, index) => (
          <div className="accordion-item border-0 border-bottom" key={index}>
            <h2 className="accordion-header" id={`heading-${index}`}>
              <button
                className={`accordion-button ${index === 0 ? "" : "collapsed"}`}
                type="button"
                data-bs-toggle="collapse"
                data-bs-target={`#collapse-${index}`}
                aria-expanded={index === 0 ? "true" : "false"}
                aria-controls={`collapse-${index}`}
                style={{ backgroundColor: "#f8f9fa", color: "#1d2736" }}
              >
                <span className="me-2 badge rounded-pill bg-white text-dark border">{index + 1}</span>
                <span>{item.title}</span>
              </button>
            </h2>
            <div
              id={`collapse-${index}`}
              className={`accordion-collapse collapse ${index === 0 ? "show" : ""}`}
              aria-labelledby={`heading-${index}`}
              data-bs-parent="#course-syllabus-accordion"
            >
              <div className="accordion-body text-dark" style={{ backgroundColor: "#f5f7fa" }}>
                <div className="d-flex align-items-start gap-2 mb-2">
                  <i className="fas fa-book-open text-primary mt-1"></i>
                  <strong>Module focus:</strong>
                </div>
                <p className="mb-0">{item.body}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DetailDescription;
